module.exports = __webpack_public_path__ + "img/7.2f068e95.jpg";